module.exports = __webpack_public_path__ + "static/img/banner.12d81c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/acadmy/banner.png
// module id = cWKw
// module chunks = 4